<section>
  <div class="container">
    <div class="flex items-center justify-between md:justify-center relative mb-[40px]">
      <h2 class="mb-0">
        {{ 'recurring-buy.headline' | translate }}
      </h2>
    </div>

    <div *ngIf="!isBlocked && isVerified">
      <div class="steps-container">
        <div class="steps-column">
          <app-transaction-step
            [stepNumber]="1"
            [printNumber]="1"
            [currentStep$]="currentStep$"
            [title]="'recurring-buy.select_cryptocurrency' | translate"
          >
            <p class="mb-[15px]">
              {{ 'recurring-buy.select_crypto_for_regular_purchase' | translate }}
            </p>
            <div class="flex">
              <div class="flex align-middle">
                <form [formGroup]="formGroup">
                  <app-select
                    formControlName="currency"
                    #currency
                    (change)="onCurrencySelected(currency.value)"
                    errorMessage="error.required-field"
                    [isValid]="true"
                  >
                    <option value="NONE" app-option>{{ 'recurring-buy.choose' | translate }}</option>
                    <option value="BTC" app-option>Bitcoin (BTC)</option>
                    <option value="ETH" app-option>Ethereum (ETH)</option>
                    <option value="XRP" app-option>Ripple (XRP)</option>
                    <option value="SOL" app-option>Solana (SOL)</option>
                    <option value="ADA" app-option>Cardano (ADA)</option>
                    <option value="LTC" app-option>Litecoin (LTC)</option>
                  </app-select>
                </form>
              </div>
            </div>
          </app-transaction-step>
          <app-transaction-step
            [stepNumber]="2"
            [printNumber]="2"
            [currentStep$]="currentStep$"
            [title]="'recurring-buy.enter_standing_order_in_your_bank' | translate"
          >
            <div class="flex flex-1 w-full flex-wrap items-start lg:flex-nowrap lg:justify-between">
              <div class="flex flex-wrap w-full lg:w-[65%]">
                <div class="w-full">
                  <app-limits
                    [user24hLimit]="paymentMethod?.limits?.user24hLimit ?? 0"
                    [user30dLimit]="paymentMethod?.limits?.user30dLimit ?? 0"
                    [currencyCode]="'CZK'"
                  ></app-limits>
                </div>
                <div
                  class="w-full md:w-[185px] bg-cm-grey-50 p-[15px] rounded-[8px] mb-[20px] md:mb-0 md:max-h-[230px] flex items-center flex-col"
                >
                  <qrcode
                    [qrdata]="paymentMethod?.depositInfo?.qrCodeData || ''"
                    [width]="150"
                    [margin]="0"
                    [scale]="1"
                    [colorLight]="'#E7E7E9'"
                    [errorCorrectionLevel]="'M'"
                    [allowEmptyString]="true"
                  >
                  </qrcode>
                  <p class="text-center !text-[12px] pt-[14px] dark:!text-black">
                    {{ 'transfers.deposit.common.qr' | translate }}
                  </p>
                </div>
                <div class="w-full sm:w-auto flex-1 px-0 py-[30px] sm:p-[30px] sm:py-0">
                  <p>
                    <strong>
                      {{ 'recurring-buy.send_payment_to_this_account' | translate }}
                    </strong>
                  </p>
                  <table *ngIf="paymentMethod?.depositInfo">
                    <tr>
                      <td>
                        {{ 'recurring-buy.account_number' | translate }}
                        <br />
                        <strong
                          >{{ paymentMethod?.depositInfo?.accountNumber }} /{{
                            paymentMethod?.depositInfo?.bankCode
                          }}</strong
                        >
                      </td>
                      <td>
                        <app-copy-to-clipboard
                          [toCopy]="
                            paymentMethod?.depositInfo?.accountNumber + '/' + paymentMethod?.depositInfo?.bankCode
                          "
                        ></app-copy-to-clipboard>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'recurring-buy.variable_symbol' | translate }}
                        <br />
                        <strong>{{ paymentMethod?.depositInfo?.variableSymbol }}</strong>
                      </td>
                      <td>
                        <app-copy-to-clipboard
                          [toCopy]="paymentMethod?.depositInfo?.variableSymbol ?? ''"
                        ></app-copy-to-clipboard>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'recurring-buy.specific_symbol' | translate }}
                        <br />
                        <strong>{{ paymentMethod?.depositInfo?.specificSymbol }}</strong>
                      </td>
                      <td>
                        <app-copy-to-clipboard
                          [toCopy]="paymentMethod?.depositInfo?.specificSymbol ?? ''"
                        ></app-copy-to-clipboard>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'recurring-buy.message_for_recipient' | translate }}
                        <br />
                        <strong>{{ paymentMethod?.depositInfo?.messageForRecipient }}</strong>
                      </td>
                      <td>
                        <app-copy-to-clipboard
                          [toCopy]="paymentMethod?.depositInfo?.messageForRecipient ?? ''"
                        ></app-copy-to-clipboard>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="w-full lg:w-[calc(35%-50px)] overflow-y-clip relative">
                <app-important-information [title]="'recurring-buy.make_payment_from_your_account' | translate">
                  <p class="!text-[14px] !leading-[1.3]">
                    {{ 'recurring-buy.send_money_only_from_your_bank_account' | translate }}
                    <br /><br />
                    <strong>
                      {{
                        'recurring-buy.minimum_deposit_is' | translate : { minAmount: paymentMethod?.limits?.minAmount }
                      }}
                    </strong>
                  </p>
                </app-important-information>
              </div>
            </div>
          </app-transaction-step>
          <app-transaction-step
            [stepNumber]="3"
            [printNumber]="3"
            [currentStep$]="currentStep$"
            [title]="'recurring-buy.credit_to_account' | translate"
          >
            <p class="mb-[30px] lg:w-[65%]">
              {{ 'recurring-buy.once_your_payment_arrives' | translate }}
            </p>
            <h4 class="flex align-middle items-center">
              <svg-icon
                class="mr-3"
                [svgStyle]="{ 'width.px': 19, 'height.px': 19 }"
                src="/assets/icons/icon-i-light.svg"
              ></svg-icon>
              {{ 'recurring-buy.want_to_know_more' | translate }}
            </h4>
            <ul class="lg:w-[65%]">
              <li>
                {{ 'recurring-buy.for_regular_purchase_of_other_cryptocurrencies' | translate }}
              </li>
              <li>
                {{ 'recurring-buy.again_select_the_desired_cryptocurrency' | translate }}
              </li>
              <li>
                {{ 'recurring-buy.the_amount_and_frequency_of_purchase' | translate }}
              </li>
              <li>
                {{ 'recurring-buy.to_stop_regular_purchases' | translate }}
              </li>
            </ul>
          </app-transaction-step>
        </div>
      </div>
    </div>
    <div class="text-center">
      <app-message
        [showMessage]="!isVerified"
        [message]="'quick-trade.main.error.no-verified' | translate"
        class="inline-block"
      >
      </app-message>
      <app-message
        [showMessage]="isBlocked"
        [message]="'quick-trade.main.error.blocked' | translate"
        class="inline-block"
      >
      </app-message>
    </div>
  </div>
</section>
